import React, { Component, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router';
import { URL } from '../../constants/constant';
import './ssoPage.css'

function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

// class SSOPage extends Component {
    const SSOPage = () => {

    // let query = useQuery();
    // const history = useHistory();
    // console.log(history)
    // history.push("profile");

    const [message, setMessage] = useState("Logging in.....")
    
    useEffect(() => {
        let url = window.location.href;
        if(url.indexOf("accessToken") > -1) {
            try {
              let access_token = url.split('?')[1].split('=')[1]
              console.log(access_token)

              //call UserProfile API here with access token

              var axios = require('axios');
              var data = JSON.stringify({
                "isSSOLogin": true,
                "authServerAccessToken": access_token
              });

              var config = {
                method: 'post',
                url: URL.mb_wapi + 'MarketPlaceLogon',
                headers: { 
                  'Content-Type': 'application/json'
                },
                data : data
              };

              axios(config)
              .then(function (response) {

                let resp = response.data;
                console.log(resp)
                if(resp && resp.isSuccess) {

                  localStorage.setItem('userDetails', JSON.stringify(resp.user.userDetails));
                  console.log(resp.user.userDetails)

                  let email = resp.user.userDetails.email;
                  console.log(email)

                  var config = {
                    method: 'get',
                    url: URL.demystify_url + 'auth/fetchUserDetails?email=' + email,
                    headers: { }
                  };
                  
                  //authorisation - check if user can access our system or not
                  axios(config)
                  .then(function (response) {
                    console.log(JSON.stringify(response.data));
                    let data = response.data;
                    if(data.success) {
                      setMessage("Logged in")
                      localStorage.setItem('isLoggedIn', true);
                      localStorage.setItem('loggedInUserDetails', JSON.stringify(data.userDetails))
                      localStorage.setItem('role', data.userDetails.role)

                      //call login api here
                      var config2 = {
                        method: 'post',
                        url: URL.demystify_url + 'auth/demystifyLogIn?email=' + email,
                        headers: { }
                      };
                      axios(config2)
                      .then(function (response) {
                        console.log(JSON.stringify(response.data));
                        if(!response.data.success) {
                          alert("Login API failed. Message: " + response.data.Message)
                        } else {
                          window.location.href = '/profiles';
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        alert("Login API failed. Message: " + error)
                      });

                    } else {
                      setMessage("Not Authorised. " + data.errorMessage)
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    setMessage("Authorisation failed. Error: " + data.errorMessage)
                  });

                } else {
                  setMessage("Could not Login. Try again from one.medibuddy.in")
                }
              })
              .catch(function (error) {
                setMessage("Could not Login. Try again from one.medibuddy.in")
                console.log(error);
              });

            } catch (error) {
              setMessage("Could not Login. Try again from one.medibuddy.in")
              console.log(error)
            }
            
        } else {
          setMessage("Could not Login. Try again from one.medibuddy.in")
        }
      }, []);

    // componentDidMount() {
    //     let url = window.location.href;
    //     if(url.indexOf("access_token") > -1) {
    //         console.log("lolol");
    //         // history.push("profile");
    //         // history.push("/login");
    //     }
    //   }
    
    // render() {
        return (
            <div className='ssoDiv'>
              <div className='txt'>
                {message}
              </div>
            </div>
          )
    // }
}

export default SSOPage